define('modules/PortalFooter/PortalFooter',[
    'jquery',
    'lodash',
    'global/all',
    'global/Logger'
], function ($, _, Roc, Logger) {
    'use strict';

    var $winHeight, $portalBody, $portalBodyHeight, $portalFooter, $offsetFooter, $heightDiffs;

    function init() {

        $winHeight = $(window).height();
        $portalBody = $('.portal-siteBody');
        $portalFooter = $('.portal-footer');

        getFooterOffset();

    };

    function getFooterOffset() {
        $portalBodyHeight = $portalBody.height();
        $heightDiffs = $winHeight - $portalBodyHeight;

        if ($heightDiffs > 150) {
            $offsetFooter = $winHeight - 59;
            $portalFooter.offset({ top: $offsetFooter });
        }
    }

    function onResize() {
        $winHeight = $(window).height();

        getFooterOffset();
    }

    window.addEventListener("resize", onResize);

    init();


    var PortalFooter = {
        init: init
    };

    Logger.debug('PortalFooter.js Loaded:', PortalFooter);

    return PortalFooter;
});
